import {Entity} from '../../../components/entity';

export class ProductParameterSize extends Entity {
  name: string;

  constructor({ id,
                name,
                createdAt, updatedAt }: Partial<ProductParameterSize>) {
    super({ id, createdAt, updatedAt });
    this.name = name ?? '';
  }

  getNameProperty(): string {
    return 'name';
  }
}
